import React, { useState } from "react"
import { makeStyles, withStyles } from "@material-ui/core/styles"
import Card from "@material-ui/core/Card"
import { Grid, Typography } from "@material-ui/core"
import Button from "@material-ui/core/Button"
import { PayPalButton } from "react-paypal-button-v2"
import ContactForm from "../FormContact"

const useStyles = makeStyles({
  root: {
    textAlign: "left",
    width: "100%",
    minHeight: 500,
    padding: 20,
    borderRadius: 20,
    paddingLeft: 30,
    paddingRight: 30,
    boxShadow: "none",
    "@media (max-width: 720px)": {
      width: "100%",
      paddingLeft: 0,
      paddingRight: 0,
      display: "flex",
      justifyContent: "center",
      alignItems: "flex-start",
    },
  },
  Logo: {
    maxHeight: 100,
    maxWidth: 180,
  },
  title: {
    color: "#003CAE",
    fontSize: 35,
    marginBottom: 10,
  },
  bodyOfText: {
    color: "#959595",
    fontSize: 17,
    margin: 0,
  },
  TextInput: {
    width: "100%",
  },
  Link: {
    fontSize: 15,
    display: "flex",
    alignItems: "center",
  },
  LinkIcon: {
    marginRight: 5,
  },
  centeredButton: {
    display: "flex",
    justifyContent: "center",
  },
  mainButton: {
    backgroundColor: "#009FAE",
    borderRadius: 20,
    textTransform: "none",
    fontWeight: 600,
    marginTop: 30,
  },
  ContainerButton: {
    display: "flex",
    justifyContent: "center",
    direction: "row",
    alignContent: "center",
  },
  TextBlue: {
    color: "#385099",
    font: "400 17px/30px Montserrat",
    marginTop: "1.5rem",
  },
  UnderlineText: {
    textDecoration: 'underline',
    cursor: 'pointer',
  }
})

const StyledButtonSig = withStyles({
  root: {
    background: "linear-gradient(90deg, #CFF31B 0%, #16B1CB 100%)",
    borderRadius: "27px",
    border: 0,
    color: "white",
    height: 48,
    width: "194px",
    padding: "0 30px",
    boxShadow: "0px 3px 6px #0000006A",
    backgroundColor: "red",
  },
  label: {
    textTransform: "none",
    fontFamily: "Helvetica",
    fontSize: "27px",
    font: "800 22px/27px Montserrat",
  },
})(Button)

function CustomCard(props) {
  const classes = useStyles()
  const { handlePayment, ChangePage, price } = props
  const [succesPayment, setSuccesPayment] = useState(false)
  const totalPrice = parseFloat(price.replace(",", "") * 1.16).toFixed(2)
  const [openContact, setOpenContact] = useState(false)
  return (
    <Card className={classes.root}>
      <Grid container spacing={3} xs={12} className={classes.ContainerButton}>
        <Grid item xs={5}>
          <PayPalButton
            createOrder={(data, actions) => {
              return actions.order.create({
                purchase_units: [
                  {
                    amount: {
                      currency_code: "MXN",
                      value: '1',
                    },
                  },
                ],
              })
            }}
            onSuccess={async details => {
              await handlePayment(details.id)
              setSuccesPayment(true)
              return null
            }}
            onError={() => console.log("error")}
          />
        </Grid>
        <Grid
          container
          direction="row"
          justify="center"
          alignItems="center"
          xs={12}
        >
          <Typography className={classes.TextBlue}>
            ¿Quieres usar otro método de pago?{" "}
            <span onClick={() => setOpenContact(true)} className={classes.UnderlineText}>Contáctanos.</span>
          </Typography>
          <ContactForm open={openContact} setOpenContact={setOpenContact} />
        </Grid>
      </Grid>
    </Card>
  )
}

export default CustomCard
